import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconAccount = function IconAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4207,
    cy: 10.8738,
    r: 4.37382,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75586 22.5003C5.75586 21.548 5.9541 20.605 6.33925 19.7252C6.7244 18.8455 7.28893 18.0461 8.0006 17.3727C8.71227 16.6993 9.55715 16.1652 10.487 15.8008C11.4168 15.4363 12.4134 15.2488 13.4199 15.2488C14.4263 15.2488 15.4229 15.4363 16.3528 15.8008C17.2826 16.1652 18.1275 16.6993 18.8392 17.3727C19.5509 18.0461 20.1154 18.8455 20.5005 19.7252C20.8857 20.605 21.0839 21.548 21.0839 22.5003",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export { IconAccount };